/** @jsxImportSource @emotion/react */
import { css } from '@emotion/react';
import { COLORS } from 'colors';

// Section
export const sectionStyle = css`
  position: relative;
  padding: 4rem 1rem;
  overflow: hidden;
`;

export const containerStyle = css`
  max-width: 1300px;
  margin: 0 auto;
  position: relative;
  z-index: 1;
`;

export const headerStyle = css`
  text-align: center;
  margin-bottom: 2rem;

  h1 {
    font-size: 2.75rem;
    font-weight: 800;
    margin-bottom: 1.25rem;
    color: ${COLORS.BLACK};
  }
`;

// Grid + Card
export const gridStyle = css`
  display: grid;
  gap: 2.5rem;
    grid-template-columns: repeat(auto-fit, minmax(290px, 1fr));

  @media (max-width: 1350px) {
    grid-template-columns: repeat(2, 1fr);
  }
  @media (max-width: 768px) {
    grid-template-columns: 1fr;
  }
  `;

export const cardStyle = css`
  border: 1px solid rgba(218, 165, 32, 0.15);
  border-radius: 1.25rem;
  transition:
    transform 0.3s ease,
    box-shadow 0.3s ease;
  position: relative;
  display: flex;
  flex-direction: column;
  height: 100%;

  &:hover {
    transform: translateY(-6px);
  }
`;

// Card content
export const cardHeaderStyle = css`
  padding: 2rem 1.5rem 1rem;
  text-align: center;
`;

export const planNameStyle = css`
  font-size: 1.5rem;
  font-weight: 700;
  color: ${COLORS.BLACK};
  margin-bottom: 0.75rem;
`;

export const planDescStyle = css`
  color: ${COLORS.GRAY_400};
  margin-bottom: 1.5rem;
  line-height: 1.5;
`;

export const priceWrapperStyle = css`
  display: flex;
  align-items: baseline;
  justify-content: center;
`;

export const priceStyle = css`
  font-size: 2.25rem;
  font-weight: 800;
  background: ${COLORS.PRIMARY};
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
`;

export const periodStyle = css`
  margin-left: 0.5rem;
  color: ${COLORS.GRAY_400};
  font-size: 1rem;
`;

// Features
export const cardBodyStyle = css`
  padding: 0 1.5rem 1.5rem;
`;

export const featuresTitleStyle = css`
  font-size: 0.95rem;
  font-weight: 700;
  margin-bottom: 1rem;
  color: ${COLORS.BLACK};
`;

export const featureStyle = css`
  display: flex;
  gap: 0.75rem;
  align-items: center;
  justify: center;
  padding-bottom: 0.65rem;

  span {
    color: ${COLORS.BLACK};
    font-size: 0.9rem;
    line-height: 1.6;
  }
`;
